import Env from '../../base/env';
import Channels from '../../base/channels';
import Component from 'gia/Component';
import gsap from 'gsap';
import { ScrollTrigger } from '../../vendor/gsap-bonus-umd/ScrollTrigger';
import easesCustom from '../../fx/CustomEases';
gsap.registerPlugin(ScrollTrigger);
import WheelIndicator from 'wheel-indicator';

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.cache = this.DOM.view.querySelector('.fxCacheSEO')
    this.DOM.fade = this.DOM.view.querySelector('.fxFade')
    this.DOM.title = this.DOM.view.querySelector('.fxTitle')
    this.DOM.svg = this.DOM.view.querySelector('svg')
    this.DOM.bgLeft = this.DOM.view.querySelector('.fxLeft')
    this.DOM.bgRight = this.DOM.view.querySelector('.fxRight')
    this.DOM.visuals = (Env.mobileCSS)?this.DOM.view.querySelectorAll('.fxVisualMobile'):this.DOM.view.querySelectorAll('.fxVisual')
    //!
    this.VARS = {}
    this.VARS.DIRECTION = 1
    this.VARS.IS_ANCHORING = false
    // //! Fns
    this.fadeScroll()
    this.makeSticky()
    this.funcLaunch = this._fx.bind(this)
    this.funcResize = this.resize.bind(this)
    this.events()

    Channels.on('launcher::exit',this.funcLaunch)
    Channels.on('transition::end',this.funcLaunch)
    Channels.on('window::smartresize',this.funcResize)
  }

  _fx()
  {
    setTimeout(() => {
      this.reveal()
    }, 75);

  }

  events()
  {
    this.indicator = new WheelIndicator({
      elem: this.DOM.view,
      callback: (e)=>{
        this.VARS.DIRECTION = e.direction
        this.moveToLimit()
      }
    });
    this.indicator.getOption('preventMouse');
  }

  fadeScroll()
  {

    this.fade = ScrollTrigger.create({
      trigger:document.body,
      start:'top top',
      end:'+=100%',
      invalidateOnRefresh: true,
      onUpdate:(e)=>{
        gsap.set(this.DOM.fade,{ autoAlpha: e.progress / 2})
      }
    })
  }

  makeSticky()
  {
    this.sticky = ScrollTrigger.create({
      trigger:this.DOM.view,
      start:'top top',
      pin:this.DOM.title,
      pinSpacing:false,
      end: () => ScrollTrigger.maxScroll(document.body),
      invalidateOnRefresh: true
    })
  }

  moveToLimit()
  {
    if(this.VARS.IS_ANCHORING == false) {
      if(this.VARS.DIRECTION == 'down') {
        const dimensions = this.DOM.bgLeft.getBoundingClientRect()
        gsap.to(
          window,
          {
            scrollTo:dimensions.height,
            duration:.8,
            ease:easesCustom.quart,
            onStart:()=>{
              this.VARS.IS_ANCHORING = true
            },
            onComplete:()=>{
              this.VARS.IS_ANCHORING = false
            }
          }
        )
      } else {
        gsap.to(
          window,
          {
            scrollTo:0,
            duration:.8,
            ease:easesCustom.quart,
            onStart:()=>{
              this.VARS.IS_ANCHORING = true
            },
            onComplete:()=>{
              this.VARS.IS_ANCHORING = false
            }
          }
        )
      }
    }
  }

  reveal()
  {
    this.animation = gsap.timeline()
    const dimensions = this.DOM.bgLeft.getBoundingClientRect()

    const clipRectLeftFrom = `rect(0px,${dimensions.width / 2}px,${dimensions.height}px,${dimensions.width / 2}px)`;
    const clipRectLeftTo = `rect(0px,${dimensions.width / 2}px,${dimensions.height}px,0px)`;
    const clipRectRightFrom = `rect(0px,${dimensions.width / 2}px,${dimensions.height}px,${dimensions.width / 2}px)`;
    const clipRectRightTo = `rect(0px,${dimensions.width}px,${dimensions.height}px,${dimensions.width / 2}px)`;

    this.animation
    .add([
      gsap.fromTo(
        this.DOM.cache,
        {
          autoAlpha:1
        },
        {
          autoAlpha:0,
          duration:.7,
          ease:easesCustom.cubic
        }
      ),
      gsap.set([this.DOM.bgLeft,this.DOM.bgRight], { autoAlpha:1})

    ])
    .add([
      gsap.fromTo(
        this.DOM.bgLeft,
        {
          clip:clipRectLeftFrom,
        },
        {
          clip:clipRectLeftTo,
          duration:1,
          ease:easesCustom.quart
        }
      ),
      gsap.fromTo(
        this.DOM.bgRight,
        {
          clip:clipRectRightFrom,
        },
        {
          clip:clipRectRightTo,
          duration:1,
          ease:easesCustom.quart
        }
      ),
      gsap.fromTo(
        this.DOM.visuals,
        {
          scale:1.2
        },
        {
          scale:1.01,
          ease:'quint.out',
          duration:1.4,
          stagger:.1,
          delay:.1
        }
      )
    ],'-=.25')
    .add([
      gsap.fromTo(
        this.DOM.svg.querySelectorAll('.masktop path'),
        {
          y:'100%'
        },
        {
          y:0,
          ease:easesCustom.quart,
          duration:.8,
          onStart:()=>{
            this.DOM.title.classList.remove('tw-invisible')
          }
        }
      ),
      gsap.fromTo(
        this.DOM.svg.querySelectorAll('.maskbottom path'),
        {
          y:'-100%'
        },
        {
          y:0,
          ease:easesCustom.quart,
          duration:.8
        }
      )
    ],'-=.5')
  }

  resize()
  {
    gsap.set([this.DOM.bgLeft,this.DOM.bgRight], { clearProps:'clip'})
  }

  unmount()
  {
    Channels.removeListener('launcher::exit',this.funcLaunch)
    Channels.removeListener('transition::end',this.funcLaunch)
    Channels.removeListener('window::smartresize',this.funcResize)
    this.fade.kill()
    this.sticky.kill()
  }
}
